<template>
    <div>
        <!-- Type -->
        <noncustom-prop v-if="object.custom_type"
            :object='object'
            :property='{label: object.custom_type.label, column: "custom_type"}'>
        </noncustom-prop>

        <!-- Creator -->
        <div class='row' v-if="creator">
            <div class='col-md-3'><strong>{{object.author.label}}</strong></div>
            <div class='col-md-9'>
                <a :href="generateLinkNew({'searchable-actors-keyword': creator})" v-html='creator'></a>
            </div>
        </div>

        <!-- Date -->
        <noncustom-prop v-if="object.origin"
            :object='object'
            :property='{label: object.origin.label, column: "origin"}'>
        </noncustom-prop>

        <!-- Custom Catalog -->
        <noncustom-prop v-if="object.custom_catalog"
            :object='object'
            :property='{label: object.custom_catalog.label, column: "custom_catalog"}'>
        </noncustom-prop>

        <!-- Archive Number -->
        <div class='row' v-if="object.custom_archive_number">
            <div class='col-md-3'><strong>{{object.custom_archive_number.label}}</strong></div>
            <div class='col-md-9'>
                {{ processArchiveNumber(object, 'custom_archive_number') }}
            </div>
        </div>
    </div>
</template>

<script>
    import ViewRelated from './../../mixins/viewRelated.js'
    import ManageProperties from './../../mixins/manageProperties.js'
    import NoncustomVue from './parts/noncustom.vue'


    export default {
        name: 'archival-fileunit-summary',
        props: ['object'],
        mixins: [ManageProperties, ViewRelated],
        components: {
            'noncustom-prop': NoncustomVue,
        },
        computed: {
            creator: function () {
                return this.concatProps(this.object, 'author', ', ')
            }
        }
    };
</script>
